export const HOVER_INTENT_DELAY_MS = 350;
export const SHOW_MESSAGE_HEIGHT_LIMIT = 45;
